// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bAsi","top":"styles_top__2veEh"};